import { Deserializable } from './deserializable';

export class ArrayResponse implements Deserializable{
  status: number;
  msg: string;
  data: [];

  deserialize(input: any, model: any): this {
    Object.assign(this, input);

    this.data = input.data.map(data => new model().deserialize(data));

    return this;
  }
}
